// extracted by mini-css-extract-plugin
export default {"html":"styles_html__Rn8on"};